import { ReactElement, useState } from 'react';
import { GenericModal } from '@/components/Modal';
import { Button, Select as DaisySelect } from 'react-daisyui';
import { Spinner } from '@/components/Spinner';

const { Option } = DaisySelect;

const valueOptions = [
  {
    color: 'red',
    options: [
      'There have been recurring Client issues.',
      'Client has voiced frustration with OpStart and is viewed to be a churn risk.',
      'Client has less than three (3) months of cash runway and no imminent funding.',
      'Client financials cannot be delivered because of lack of system access or other roadblocks.',
      'Client is churned or churning.',
    ],
  },
  {
    color: 'yellow',
    options: [
      'Client has less than six (6) months of cash runway and is actively needing/trying to raise funds.',
      'Client leadership is in transition.',
      'Client is currently being acquired.',
      'Strained client relationship with OpStart or non-responsive to us.',
      'Has not been paying OpStart invoices.',
      'Client profitability is below target.',
      'Client financials have not been delivered in a timely manner.',
      'Client has hired full-time finance/accounting staff (e.g. full-time CFO, Controller, or Accounting Manager).',
    ],
  },
  {
    color: 'green',
    options: [
      'Client seems happy and relationship seems strong.',
      'Work is going smoothly and efficiently, and profitability targets are being met.',
      'Client payments are up to date.',
      'Client has more than seven (7) months of cash runway.',
    ],
  },
] as {
  color: string;
  options: string[];
}[];

interface Props {
  isOpen: boolean;
  color: string;
  onClose: () => void;
  onSave: (comment: string, color: string) => Promise<string>;
}
function UpdateRiskStatusModal({ isOpen, color, onClose, onSave }: Props) {
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const options =
    valueOptions.find((option) => option.color === color)?.options || [];

  const handleSubmit = async (e: React.FormEvent) => {
    setIsLoading(true);
    e.preventDefault();
    const result = await onSave(comment, color);
    if (result) {
      setComment('');
    }
    setIsLoading(false);
  };

  return (
    <GenericModal isOpen={isOpen} onClose={onClose} className='min-w-max'>
      <div className='p-4'>
        <h2 className='text-base uppercase font-bold'> Churn Risk</h2>
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <div className='mt-0 space-y-4'>
          <div className='flex flex-wrap gap-4 pb-2 mt-0'>
            <div className='font-bold text-sm w-[100%] text-left pl-3'>
              <DaisySelect
                value={comment}
                className='select select-bordered select-accent w-full mt-4'
                onChange={(value) => setComment(value)}
              >
                <Option value='' disabled>
                  Select a reason
                </Option>
                {
                  options?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  )) as unknown as ReactElement
                }
              </DaisySelect>
            </div>
          </div>
        </div>
        <div className='flex w-full justify-around'>
          <Button
            type='submit'
            title='login'
            color='accent'
            variant='outline'
            size='sm'
            className='btn btn-accent bg-transparent p-2 m-2 ml-0'
            data-testid='cancel-custom-request-button'
            disabled={isLoading}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type='button'
            title='login'
            color='accent'
            size='sm'
            className='btn btn-accent bg-transparentp-2 m-2 ml-4'
            data-testid='confirm-custom-request-button'
            disabled={!comment || isLoading}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleSubmit}
          >
            Confirm
            {isLoading && <Spinner className='mx-auto w-4 text-base ml-4' />}
          </Button>
        </div>
      </div>
    </GenericModal>
  );
}

export default UpdateRiskStatusModal;
